import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { api } from '../api/client';

export default function TaskCompletePage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { register, handleSubmit, watch, setValue, formState: { errors } } = useForm({
    defaultValues: { output_text: '' },
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [aiLoading, setAiLoading] = useState(true);
  const [aiDetailLoading, setAiDetailLoading] = useState(false);
  const [aiError, setAiError] = useState('');

  const outputText = watch('output_text', '');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setAiLoading(true);
      setAiError('');
      try {
        await api.getTask(id);
        const { data } = await api.generateOutput(id, 'short');
        if (!cancelled && data?.output_text) {
          setValue('output_text', data.output_text);
        }
      } catch (err) {
        if (!cancelled) {
          setAiError(err.response?.data?.detail || 'Özet oluşturulamadı; metni kendiniz yazabilirsiniz.');
        }
      } finally {
        if (!cancelled) setAiLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [id, setValue]);

  const onDetail = async () => {
    setAiDetailLoading(true);
    setAiError('');
    try {
      const { data } = await api.generateOutput(id, 'detailed');
      if (data?.output_text) setValue('output_text', data.output_text);
    } catch (err) {
      setAiError(err.response?.data?.detail || 'Detaylı özet alınamadı.');
    } finally {
      setAiDetailLoading(false);
    }
  };

  const onSubmit = async (data) => {
    setLoading(true);
    setError('');
    try {
      await api.completeTask(id, {
        output_text: data.output_text,
      });
      navigate('/satis');
    } catch (err) {
      setError(err.response?.data?.detail || 'Hata oluştu, tekrar deneyin.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="px-4 py-6">
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">

        {/* İş Çıktısı */}
        <div>
          <div className="flex items-center justify-between gap-2 mb-1">
            <label className="block text-sm font-medium text-gray-700">
              İş Çıktısı <span className="text-red-500">*</span>
            </label>
            <button
              type="button"
              className="text-xs font-semibold text-brand-600 disabled:opacity-50"
              onClick={onDetail}
              disabled={aiLoading || aiDetailLoading}
            >
              {aiDetailLoading ? 'Detaylandırılıyor...' : 'Detaylandır'}
            </button>
          </div>
          <div className="relative">
            {(aiLoading || aiDetailLoading) && (
              <div className="absolute inset-0 z-10 bg-white/70 flex items-center justify-center rounded-xl border border-gray-200">
                <div className="flex flex-col items-center gap-2 text-sm text-gray-600">
                  <svg className="animate-spin h-6 w-6 text-brand-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                  </svg>
                  <span>{aiLoading ? 'Özet hazırlanıyor...' : 'Güncelleniyor...'}</span>
                </div>
              </div>
            )}
            <textarea
              className="input min-h-[140px] resize-none"
              placeholder="Bu işin somut sonucunu yazın. Örn: Avient ile fiyat güncellemesi görüşmesi tamamlandı, %5 indirim üzerinde anlaşıldı."
              {...register('output_text', {
                required: 'İş çıktısı zorunludur.',
                minLength: { value: 10, message: 'En az 10 karakter girin.' },
              })}
            />
          </div>
          {errors.output_text && (
            <p className="text-xs text-red-500 mt-1">{errors.output_text.message}</p>
          )}
          {aiError && !errors.output_text && (
            <p className="text-xs text-amber-700 mt-1">{aiError}</p>
          )}
          <p className="text-xs text-gray-400 mt-1 text-right">{outputText.length} karakter</p>
        </div>

        {/* Uyarı kutusu */}
        <div className="bg-amber-50 border border-amber-200 rounded-xl px-4 py-3">
          <p className="text-xs text-amber-700">
            İş çıktısı kaydedildikten sonra bu iş tekrar açılamaz.
            Devam etmeden önce bilgilerin doğru olduğundan emin olun.
          </p>
        </div>

        {error && (
          <div className="bg-red-50 border border-red-200 rounded-xl px-4 py-3 text-sm text-red-700">
            {error}
          </div>
        )}

        <button
          type="submit"
          className="btn-primary"
          disabled={loading || !outputText.trim() || aiLoading}
        >
          {loading ? 'Kaydediliyor...' : 'Tamamlandı Olarak Kaydet'}
        </button>

        <button
          type="button"
          className="btn-secondary"
          onClick={() => navigate(-1)}
        >
          Geri Dön
        </button>
      </form>
    </div>
  );
}
